import { Routes, Route } from 'react-router-dom';
import { ProtectedRoute } from '@/components/common/ProtectedRoute';
import { useSelector } from 'react-redux';
import { RootState } from './store';
// import { useIsAuthenticated } from './hooks';
import {
  AccountDetails,
  // AccountStatement,
  AccountSummary,
  ActivityLog,
  ActivityLogs,
  // AffiliateListing,
  // AffiliateReq,
  AllDownlineListing,
  Settlement,
  BankerDetail,
  BannerManagement,
  BetList,
  BetSetting,
  BussinessReports,
  CasinoBetList,
  CasinoControl,
  CasinoDetail,
  CasinoPlByDownline,
  CasinoPlByPlayer,
  CategoryControl,
  // ComissionReport,
  // AffiliateActiveUserOfWeek,
  ContentManagement,
  // DashBoard,
  // DashboardPage,
  DWRequest,
  EventManagement,
  Export,
  FilteredGames,
  GameControl,
  InactiveMemerList,
  Login,
  ManageAccount,
  NotFoundPage,
  NotificationManagement,
  OnboardingPage,
  PlByEvent,
  PlByPlayer,
  PlDownline,
  ProviderControl,
  Setting,
  SubUsers,
  // SubUsersListing,
  SupportContactManagement,
  // TransactionCode,
  TransactionHistory,
  UserAccountStatement,
  UserBetHistory,
  UserBettingPL,
  AuthLayout,
  DashboardLayout,
  RoleWiseAccountStatement,
  BonusStatement,
  PolicyManagement,
  AddPromotion,
  RolesAndPrivileges,
  Roles,
  AccessControl,
  CreateRoles,
  GeneralSettingPage,
} from '@/components/routes';
import DashboardPageTwo from './pages/dashboard/DashboardPageTwo';
import { PermissionProvider } from './context/PermissionContext';
import { Permission } from './types/rolesTypes';
import { useGetUserRolesDetailsQuery } from './store/api/rolesApi';
import { skipToken } from '@reduxjs/toolkit/query';
import ModuleRoute from './components/ModuleRoute';

export function App() {
  // useEffect(() => {
  //   const bankerDomain = import.meta.env.VITE_BANKER_URL;
  //   const adminDomain = import.meta.env.VITE_ADMIN_URL;

  //   if (location.href.includes(bankerDomain)) {
  //     document.title = 'Rebel Exchange Banker';
  //   } else if (location.href.includes(adminDomain)) {
  //     document.title = 'Rebel Exchange Admin/Agent';
  //   }
  // }, []);
  const user = useSelector((state: RootState) => state.user);
  const userId = user?.data?.id;
  const { data, isLoading } = useGetUserRolesDetailsQuery(userId ? Number(userId) : skipToken, {
    skip: !userId,
  });
  const userData = data?.data?.[0];

  return (
    <PermissionProvider user={userData as Permission} isLoading={isLoading}>
      <Routes>
        {/* Auth Routes */}
        <Route element={<AuthLayout />}>
          <Route path="/login" element={<Login />} />
          {/* <Route path="/register" element={<RegisterPage />} /> */}
        </Route>

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route element={<DashboardLayout />}>
            <Route
              path="/"
              element={
                <ModuleRoute moduleName="Dashboard">
                  <DashboardPageTwo />
                </ModuleRoute>
              }
            />
            <Route
              path="/dashboard"
              element={
                <ModuleRoute moduleName="Dashboard">
                  <DashboardPageTwo />
                </ModuleRoute>
              }
            />
            <Route path="/onboarding" element={<OnboardingPage />} />
            {/* Downline Routes */}
            <Route path="/settlement" element={<Settlement />} />
            <Route element={<ModuleRoute moduleName="Users" />}>
              <Route path="/members/:id" element={<AllDownlineListing />} />
              <Route path="/members/:id/:role/:user/:memberid/:upline" element={<SubUsers />} />
            </Route>

            <Route
              path="/members/:id/sub/:memberid"
              element={
                <ModuleRoute
                  moduleName="Users"
                  anyAccess={['update', 'detailedView']}
                  // requiredAccess={['read', 'detailedView']}
                >
                  <AccountDetails />
                </ModuleRoute>
              }
            >
              <Route index element={<AccountSummary />} />
              <Route
                path="account-summary"
                element={
                  <ModuleRoute
                    moduleName="Users"
                    anyAccess={['update', 'detailedView']}
                    // requiredAccess={['read', 'update']}
                  >
                    <AccountSummary />
                  </ModuleRoute>
                }
              />
              <Route
                path="account-statement"
                element={
                  <ModuleRoute moduleName="Users" requiredAccess={['read', 'detailedView']}>
                    <UserAccountStatement />
                  </ModuleRoute>
                }
              />
              <Route
                path="bet-history"
                element={
                  <ModuleRoute moduleName="Users" requiredAccess={['read', 'detailedView']}>
                    <UserBetHistory />
                  </ModuleRoute>
                }
              />
              <Route
                path="betting-pl"
                element={
                  <ModuleRoute moduleName="Users" requiredAccess={['read', 'detailedView']}>
                    <UserBettingPL />
                  </ModuleRoute>
                }
              />
              <Route
                path="casino-detail"
                element={
                  <ModuleRoute moduleName="Users" requiredAccess={['read', 'detailedView']}>
                    <CasinoDetail />
                  </ModuleRoute>
                }
              />

              <Route
                path="transaction-history"
                element={
                  <ModuleRoute moduleName="Users" requiredAccess={['read', 'detailedView']}>
                    <TransactionHistory />
                  </ModuleRoute>
                }
              />
              <Route
                path="login-history"
                element={
                  <ModuleRoute moduleName="Users" requiredAccess={['read', 'detailedView']}>
                    <ActivityLog />
                  </ModuleRoute>
                }
              />
            </Route>

            {/* Banker Management */}
            <Route element={<ModuleRoute moduleName="BankingManagement" />}>
              <Route path="/bankers/:id/:details?/:mode?/:type?" element={<BankerDetail />} />
              <Route
                path="/requests/:mode?/:type?"
                element={
                  <ModuleRoute
                    moduleName="BankingManagement"
                    requiredAccess={['read', 'manageRequest']}
                  >
                    <DWRequest />
                  </ModuleRoute>
                }
              />
              <Route
                path="/manage-account/:type?"
                element={
                  <ModuleRoute
                    moduleName="BankingManagement"
                    requiredAccess={['read', 'manageAccount']}
                  >
                    <ManageAccount />
                  </ModuleRoute>
                }
              />
            </Route>
            {/* <Route path="/account-statement" element={<AccountStatement />} /> */}
            {/* <Route path="/banker-dashboard" element={<BankerDashboard />} /> */}

            {/* Content Management */}
            <Route element={<ModuleRoute moduleName="ContentManagement" />}>
              <Route path="/content-management" element={<ContentManagement />}>
                <Route index element={<BannerManagement />} />
                <Route path="Notification" element={<NotificationManagement />} />
                <Route path="Contact" element={<SupportContactManagement />} />
              </Route>
              <Route path="/add-promotion" element={<AddPromotion />} />
            </Route>

            {/* Affiliate Management */}
            {/* <Route path="/affiliate-dashboard" element={<DashBoard />} />
          <Route path="/affiliate-req" element={<AffiliateReq />} />
          <Route path="/affiliate-list" element={<AffiliateListing />} />
          <Route path="/affiliate-list/:id" element={<SubUsersListing />} />
          <Route path="/affiliate-comission-report" element={<ComissionReport />} />
          <Route path="/affiliate-comission-report/:id" element={<AffiliateActiveUserOfWeek />} />
          <Route path="/affiliate-setting" element={<AffiliateSetting />} /> */}

            {/* Casino management */}
            <Route element={<ModuleRoute moduleName="CasinoControl" />}>
              <Route path="/casino-management" element={<CasinoControl />}>
                <Route index element={<CategoryControl />} />
                <Route path="provider" element={<ProviderControl />} />
                <Route path="game" element={<GameControl />} />
              </Route>
              <Route path="/casino-management/games" element={<FilteredGames />} />
            </Route>

            {/* Commission Settings route */}
            <Route path="/commission-setting" element={<GeneralSettingPage />} />

            {/* Change Password Routes */}
            <Route path="/settings" element={<Setting />} />

            {/* Event Management*/}
            <Route element={<ModuleRoute moduleName="EventManagement" />}>
              <Route path="/event-management/:status?" element={<EventManagement />} />
              <Route path="/bet-setting" element={<BetSetting />} />
            </Route>

            {/* Risk Management Routes */}
            {/* <Route path="/risk" element={<Risk />} /> */}

            {/* Reports Routes */}
            <Route element={<ModuleRoute moduleName="MyReport" />}>
              <Route path="/bet-list" element={<BetList />} />
              <Route path="/casino-bet-list" element={<CasinoBetList />} />
              <Route path="/pl-by-downline" element={<PlDownline />} />
              <Route path="/pl-by-player" element={<PlByPlayer />} />
              <Route path="/pl-by-event" element={<PlByEvent />} />
              <Route path="/casinopl-by-player" element={<CasinoPlByPlayer />} />
              <Route path="/casinopl-by-downline" element={<CasinoPlByDownline />} />
              <Route path="/inactive-members" element={<InactiveMemerList />} />
              <Route path="/business-reports" element={<BussinessReports />} />
            </Route>

            <Route path="/activity-logs" element={<ActivityLogs />} />

            {/* Export History */}
            <Route path="/export" element={<Export />} />

            {/* Account statement */}
            <Route
              path="/account-statement"
              element={
                <ModuleRoute moduleName="Account Statement">
                  <RoleWiseAccountStatement />
                </ModuleRoute>
              }
            />
            {/* Bonus Management */}
            <Route element={<ModuleRoute moduleName="Bonus" />}>
              <Route path="/bonus">
                <Route path="policy-management" element={<PolicyManagement />} />
                <Route path="statement" element={<BonusStatement />} />
              </Route>
            </Route>

            {/* Roles And Privileges */}
            {/* <Route path="/roles-and-privileges" element={<RolesAndPrivileges />}>
              <Route index element={<Roles />} />
              <Route path="access" element={<AccessControl />} />
            </Route>
            <Route path="create-roles/:id?/:type?" element={<CreateRoles />} /> */}

            <Route element={<ModuleRoute moduleName="Roles Privileges" />}>
              <Route path="/roles-and-privileges" element={<RolesAndPrivileges />}>
                <Route index element={<Roles />} />
                <Route path="access" element={<AccessControl />} />
              </Route>
              <Route
                path="create-roles/:id?/:type?"
                element={
                  <ModuleRoute moduleName="Roles Privileges" requiredAccess={['read', 'create']}>
                    <CreateRoles />
                  </ModuleRoute>
                }
              />
            </Route>
          </Route>
        </Route>
        {/* </Route> */}
        {/* <Route path="/transaction-code" element={<TransactionCode />} /> */}

        {/* 404 */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </PermissionProvider>
  );
}
